import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { AddProjectPart } from '../../project.model';

@Component({
  selector: 'app-add-project-part-dialog',
  templateUrl: './add-project-part-dialog.component.html',
  styleUrls: ['./add-project-part-dialog.component.scss']
})
export class AddProjectPartDialogComponent implements OnInit {

  name: string;

  formGroup = new FormGroup({});

  confirmDisabled = false;

  projectId: number;
  parentPartId: number;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AddProjectPartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {

    this.projectId = data.projectId;
    this.parentPartId = data.parentPartId;

    this.formGroup.addControl('name', new FormControl('', [Validators.required]));


  }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(formValues => {
      this.name = formValues.name;
    });

    this.formGroup.statusChanges.subscribe(newStatus => {
      this.confirmDisabled = !this.formGroup.valid;
    });

    this.confirmDisabled = !this.formGroup.valid;
    this.formGroup.markAllAsTouched();

  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.http.postWithContext<number>(environment.erpProjectEndpoint + '/addProjectPart',
      new AddProjectPart({ projectId: this.projectId, parentPartId: this.parentPartId, name: this.name }))
      .subscribe(response => {

        console.log('response is', response);

        this.dialogRef.close();

      }, error => {
        console.log('error is', error);
      });
  }

}
